Vue.directive('number-only', {
	bind(el) {
		el.addEventListener('keypress', (e) => {
			//-1 !== $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) || /65|67|86|88/.test(e.keyCode) && (!0 === e.ctrlKey || !0 === e.metaKey) || 35 <= e.keyCode && 40 >= e.keyCode || (e.shiftKey || 48 > e.keyCode || 57 < e.keyCode) && (96 > e.keyCode || 105 < e.keyCode) && e.preventDefault()
			var charCode = e.which ? e.which : e.keyCode;
			if (charCode < 48 || charCode > 57) {
				if (charCode != 8) {
					e.preventDefault();
				}
			}
		});
	}
});
Vue.directive('decimal-numbers', {
	bind(el) {
		el.addEventListener('keypress', (evt) => {
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault();
			} else {
				var val = evt.target.value;
				var indexOfPeriod = val.indexOf('.');
				if (indexOfPeriod != -1 && charCode == 46) {
					evt.preventDefault();
				}

				// position of new character
				var pos = evt.target.selectionStart;
				// Split the value
				var s = val.split('.');

				if (s.length > 1 && s[1].length > 1 && pos > indexOfPeriod) {
					evt.preventDefault();
				}
			}
		});
	}
});

Vue.directive('textarea-auto-height', {
	bind(el) {
		setTimeout(() => {
			el.style.height = el.scrollHeight > el.clientHeight ? 10 + el.scrollHeight + 'px' : '20px';
		}, 1000);
		el.addEventListener('keyup', (e) => {
			e.target.style.height = '20px';
			e.target.style.height = 10 + e.target.scrollHeight + 'px';
		});
	}
});

// Vue click outside directive
// https://codepen.io/mahendranKannan/pen/MEBGGM
var eventObj;
Vue.directive('click-outside', {
	bind: function(el, binding, vnode) {
		eventObj = function(event) {
			if (
				!(
					el == event.target ||
					el.contains(event.target) ||
					event.target.className === 'select2-selection__choice__remove'
				) &&
				(event.target.className !== `js-click-outside-show-trigger-${el.getAttribute('data-index')}` ||
					event.target.className !== `js-click-outside-show-trigger-next-${el.getAttribute('data-index')}`)
			) {
				vnode.context[binding.expression](event, el);
			}
		};
		document.body.addEventListener('click', eventObj);
	},
	unbind: function(el) {
		document.body.removeEventListener('click', eventObj);
	}
});

// Vue click outside directive for dynamic elements
// https://github.com/ndelvalle/v-click-outside/blob/master/lib/v-click-outside.js
import directive from './directives/v-click-outside.js';
Vue.directive('click-outside-for-dynamic-elements', directive);

Vue.directive('phone-number', {
	bind(el) {
		el.addEventListener('keypress', (e) => {
			let keyCode = e.which ? e.which : e.keyCode;
			let keyCodeFilter = keyCode < 48 || keyCode > 57;
			let lengthFilter = el.children[0].value.length > 30;
			let allowedKeyCodes = [
				43, // +
				40, //(
				41, //)
				32, //Space
				45 //-
			];
			if ((allowedKeyCodes.indexOf(keyCode) == -1 && keyCodeFilter) || lengthFilter) {
				if (keyCode != 8) {
					e.preventDefault();
				}
			}
		});

		// el.addEventListener("paste", (e) => {
		//     setTimeout(() => {
		//         let val = el.children[0].value
		//         let patt = /^[\d\(\)\+\s\-]+$/gi
		//         if (!patt.test(val)) {
		//             el.children[0].value = ''
		//         }
		//     }, 50)
		// });
	}
});
Vue.directive('highLightColor', {
	inserted(el, binding, vnode) {
		var query = vnode.context[binding.arg];
		el.innerHTML = binding.value.replace(new RegExp(query, 'gi'), (match) => {
			return '<span style="background: yellow;">' + match + '</span>';
		});
	},
	update(el, binding, vnode) {
		var query = vnode.context[binding.arg];
		el.innerHTML = binding.value.replace(new RegExp(query, 'gi'), (match) => {
			return '<span style="background: yellow;">' + match + '</span>';
		});
	}
});

Vue.directive('alpha-numeric', {
	bind(el) {
		el.addEventListener('keypress', (evt) => {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				(charCode >= 48 && charCode <= 57) ||
				(charCode >= 65 && charCode <= 90) ||
				(charCode >= 97 && charCode <= 122)
			) {
				return true;
			} else {
				evt.preventDefault();
			}
		});
	}
});

Vue.directive("formi9-name", {
  bind(el) {
    el.addEventListener("keypress", e => {
      let keyCode = e.which ? e.which : e.keyCode;
      let lengthFilter = el.children[0].value.length > 30;
      let vallength = e.target.value.length;
      let keyCodeFilter =
        (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122);
      let allowedKeyCodes = [
        32, //space
        45, //-
        39, //'
        46, //.
      ];
      if (
        (allowedKeyCodes.indexOf(keyCode) == -1 && !keyCodeFilter) ||
        lengthFilter
      ) {
        if (keyCode != 8) {
          e.preventDefault();
        }
      }
    });

    el.addEventListener("paste", e => {
     // e.preventDefault();
     setTimeout(() => {
      let val = el.children[0].value;
      //let patt = /^[a-zA-Z\''\-\s.]*$/gi;
      let finalValue = val.replace(/[^a-zA-Z\''\-\s.]/g, '')
      el.children[0].value = finalValue;
    }, 50);
    });
  }
});

// Vue read more directive
// Usage: https://github.com/orlyyani/read-more
import readMore from './directives/ReadMoreDirective.js';
Vue.directive('readMore', readMore);
import infiniteScroll from 'vue-infinite-scroll';
Vue.directive('infinte-Scroll', infiniteScroll);



// WEBPACK FOOTER //
// ./src/components/Core/directives.js